import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux'
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { position } from '../../redux/actions/filterActions';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";
import arrowDown from '../../assets/arrowdown.SVG';

const useStyles = makeStyles({
    selectBorder: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0000ff00',
        },
    },
    imageIcon: {
        position: 'absolute',
        marginLeft: isMobile ? 298 : 275,
        pointerEvents: 'none',
    }
});

const ArrowIcon = () =>{
    const classes = useStyles();

    return(
        <img className={classes.imageIcon} src={arrowDown}/>
    );
}

const Position = ({ position }) => {
    const classes = useStyles();
    const [state, setState] = useState('');
    const currentDirection = useSelector((state) => state.filterReducer.direction);

    const [classifier, setClassifier] = useState([]);
    const handleChange = (event) => {
        setState(event.target.value);
        localStorage.setItem('position', event.target.value);
    };

    useEffect(() => {
        if (currentDirection && currentDirection.positions) {
            setClassifier(currentDirection.positions);
            if (localStorage.getItem('position')) {
                setState(localStorage.getItem('position'));
                position(localStorage.getItem('position'));
            }
        } else {
            setState('');
            setClassifier([]);
        }
    }, [currentDirection, position])

    const handleMenuItemClick = (idx) => {
        position(idx || idx === 0 ? classifier[idx] : '');
    };

    return (
        <FormControl variant="outlined" >
            <InputLabel shrink={true} classes={{ root: classes.label }}>Должность *</InputLabel>
            <Select
                className={classes.selectBorder}
                value={state}
                onChange={handleChange}
                label="Направление"
                variant="outlined"
                IconComponent = {ArrowIcon}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    getContentAnchorEl: null
                }}
            >
                <MenuItem key={-1} value={-1} onClick={() => handleMenuItemClick()}>
                    &nbsp;
                </MenuItem>
                {classifier.map((option, index) => (
                    <MenuItem key={index} value={option} onClick={() => handleMenuItemClick(index)}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

const mapStateToProps = state => ({
    position: state.position,
    direction: state.filterReducer.direction,
})

export default connect(mapStateToProps, { position, })(Position)
